import { useApi } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { CareModel } from '../types';

export type UserPublicInfo = {
  // The display name of the affiliate
  affiliate?: string;
  coach_id: string;
  timezone: string;
  care_model: CareModel;
  phone_number_provided: boolean;
  // True when the user pays through Stripe rather than being covered by an
  // affiliate. The backend excludes the `sub_covered` sentinel.
  is_stripe?: boolean;
  // utm_source of the affiliate which referred the user. Distinct from
  // `affiliate` above, which is the display name of the affiliate they signed
  // up via, and which can be a different affiliate.
  referrer?: string | null;
};

export const useUserPublicInfo = (
  userId: string | undefined,
  throwIfError = false
) => {
  const { api } = useApi({ throwIfError });

  const fetchPublicInfo = async (): Promise<UserPublicInfo> => {
    return api({
      route: `/user/${userId}/`,
    });
  };

  const { data, isInitialLoading, isLoading, isError } = useQuery<
    UserPublicInfo,
    Error
  >({
    queryKey: ['public-user-info', userId],
    queryFn: fetchPublicInfo,
    enabled: !!userId,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading: isLoading || isInitialLoading,
    isError,
    data,
  };
};
